import gql from 'graphql-tag';
import { PiList, PiListSubscription, Prospect } from '../server-types';

const prospectFragment = gql`
	fragment ProspectFragment on Prospect {
		id
		piId
		email
		piListSubscriptions {
			PiList {
				id
			}
		}
	}
`;
export type ProspectFragmentType = Pick<Prospect, 'id' | 'piId' | 'email'> & {
	piListSubscriptions: Pick<PiListSubscription, 'didOptIn' | 'didOptOut'> & {
		PiList: Pick<PiList, 'id'>;
	};
};

const magazineCardFragment = gql`
	fragment MagazineCardFragment on Magazine {
		id
		name
		title
		category
		issueNumber
		publicationDate
		featuredImageMedia {
			id
			smallThumbUrl
			mediumThumbUrl
		}
		featuredImageSizes
		featuredImageUrl
		customHighlightDays
		MagazineCollection {
			id
			highlightDays
			name
			BrandSf
		}
	}
`;

const magazineLastIssuesSliderQuery = gql`
	query LastIssuesQuery {
		magazines(filter: { isPublished: true, notInLatestIssues: false }, first: 15) {
			edges {
				node {
					...MagazineCardFragment
				}
			}
		}
	}
	${magazineCardFragment}
`;

export { prospectFragment, magazineLastIssuesSliderQuery, magazineCardFragment };
